import { useCarousel } from '@/common/hooks/useCarousel';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export const useProductImageCarousel = props => {
  const { images, type, imageWidth, setCurrentIndex } = props;
  const [carouselState, carouselApi] = useCarousel(images);
  const { activeItemIndex, sortedImages } = carouselState;
  const { handlePrevious, handleNext, setActiveItemIndex } = carouselApi;

  const [showVideo, setShowVideo] = useState(false);
  const [currentProductImageIndex, setCurrentProductImageIndex] = useState(0);

  const handleThumbnailClick = useCallback(
    index => {
      setShowVideo(false);
      setActiveItemIndex(index);
    },
    [setActiveItemIndex],
  );

  const prevPropsRef = useRef({ images });

  if (prevPropsRef.current.images !== images) {
    prevPropsRef.current.images = images;
    setActiveItemIndex(0);
  }

  useEffect(() => {
    setCurrentIndex && setCurrentIndex(activeItemIndex);
  }, [activeItemIndex, setCurrentIndex]);

  const currentImage = useMemo(() => {
    return sortedImages[activeItemIndex] || {};
  }, [sortedImages, activeItemIndex]);

  const altText = currentImage.label || 'image-product';

  return {
    currentImage,
    activeItemIndex,
    altText,
    handleNext,
    handlePrevious,
    handleThumbnailClick,
    sortedImages,
    currentProductImageIndex,
    setCurrentProductImageIndex,
    showVideo,
    setShowVideo,
  };
};
